// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
	'use strict'


	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	var forms = document.querySelectorAll('.needs-validation')

	// custom checkboxfield and radiofield validation
	// select one form
	forms.forEach(
		function (form) {

			//data attribute require
			form.querySelectorAll('.field__checkboxfield[data-required="1"], .field__radiofield[data-required="1"]').forEach(
				function (field) {
					var inputs = field.querySelectorAll('input.field__input');
					function checkCheckboxes () {
						var isChecked = false;
						inputs.forEach(
							(input) => {
								if (input.checked) {
									isChecked = true;
								}
							}
						)
						// if isChecked = true => required = false
						inputs.forEach(
							(input) => {
								input.required = !isChecked;
							}
						)

						// listener when "Weiter"-button is selected
						form.addEventListener('submit',  (checkbox) => {

							// gets object with class 'invalid feedback'
							// getElementsByClassName returns a list of objects, therefore [index] is necessary
							var errorMessage = field.getElementsByClassName('invalid-feedback')[0];
							// if no checkbox is checked, display the error message
							if (isChecked === false) {
								errorMessage.classList.add('field__invalid');
							}
							else {
								errorMessage.classList.remove('field__invalid');
							}
						})
					}
					// initial on-page load
					checkCheckboxes ();
					// load if checkbox state changes
					inputs.forEach(
						(input) => {
							input.addEventListener('change', checkCheckboxes);
						}
					)
				}
			)

			var uploades = form.querySelectorAll('.formfield-upload[required="required"]');
			console.log(uploades);
			// listener when "Weiter"-button is selected
			if (uploades.length > 0) {
				form.addEventListener('submit', (test) => {
					// console.log("works");
					uploades.forEach(
						(upload) => {
							// console.log(upload);
							if (upload.value === "") {
								// console.log("nothing to see");
								upload.classList.add('field__input--invalid');
								upload.nextElementSibling.getElementsByClassName('uploadfield__button-container')[0].classList.remove('uploadfield__valid');
								upload.nextElementSibling.getElementsByClassName('field__error')[0].classList.add('uploadfield__error');
							}
						}
					)
				})
			}
		}
	)

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms).forEach(function (form) {
		form.setAttribute('novalidate', 'novalidate');
		form.addEventListener('submit', function (event) {
			if (!form.checkValidity()) {
				event.preventDefault()
				event.stopPropagation()
			}

			form.classList.add('was-validated')
		}, false)
	})

	var uploadfields = document.getElementsByClassName('formfield-upload');

	if (uploadfields.length > 0) {
		Array.prototype.slice.call(uploadfields).forEach(function (uploadfield) {
			// calls everytime there's a change to the uploaded file
			uploadfield.addEventListener('change', function (event) {
				// console.log(uploadfield.files[0]);
				// console.log(uploadfield.files[0].name.split('.').pop());
				// console.log(uploadfield.getAttribute("accept"));

				// if the file uploaded is of the accepted file types
				// adds and removes classes accordingly
				if (uploadfield.getAttribute("accept").includes(uploadfield.files[0].name.split('.').pop())) {
					uploadfield.classList.add('field__input--valid');
					uploadfield.classList.remove('field__input--invalid');
					uploadfield.nextElementSibling.getElementsByClassName('uploadfield__button-container')[0].classList.add('uploadfield__valid');
					uploadfield.nextElementSibling.getElementsByClassName('field__error')[0].classList.remove('uploadfield__error');
				} else {
					uploadfield.classList.remove('field__input--valid');
					uploadfield.classList.add('field__input--invalid');
					uploadfield.nextElementSibling.getElementsByClassName('uploadfield__button-container')[0].classList.remove('uploadfield__valid');
					uploadfield.nextElementSibling.getElementsByClassName('field__error')[0].classList.add('uploadfield__error');
				}
			})
		})
	}
})()


document.getElementById('datamints-formgenerator').addEventListener('submit', function (e) {
	const inputField = document.getElementById('inbetriebsetzungsTermin');
	const input = inputField.value.trim();

	// Allow empty input if 'required' attribute is not set
	if (!input && !inputField.hasAttribute('required')) {
		return;
	}
	// Check format YYYY-MM-DD
	const dateRegex = /^\d{2}.\d{2}.\d{4}$/;
	if (!dateRegex.test(input)) {
		e.preventDefault();
		return;
	}

	const [day, month, year] = input.split('.');
	const inputDate = new Date(`${year}-${month}-${day}`);

	const today = new Date();
	const sevenDaysAgo = new Date();
	sevenDaysAgo.setDate(today.getDate() - 7);

	// Reset time to midnight for accurate comparison
	inputDate.setHours(0,0,0,0);
	today.setHours(0,0,0,0);
	sevenDaysAgo.setHours(0,0,0,0);

	const errorMessage = document.getElementById('field-error-inbetriebsetzungsTermin');

	if (inputDate < sevenDaysAgo) {
		e.preventDefault();
		errorMessage.style.display = 'block';
	} else {
		errorMessage.style.display = 'none';
	}
});
